const INVOICE_CACHE_PREFIX = "pdf_invoice_"
const RECEIPT_CACHE_PREFIX = "pdf_receipt_"
const CACHE_EXPIRY_DAYS = 7 

export const pdfStore = {
  getCacheKey: (id, type = "invoice") => {
    const prefix = type === "receipt" ? RECEIPT_CACHE_PREFIX : INVOICE_CACHE_PREFIX
    return `${prefix}${id}`
  },

  storeInvoicePdf: async (invoiceId, pdfUrl, metadata = {}) => {
    try {
      const cacheData = {
        url: pdfUrl,
        metadata: {
          companyId: metadata.shopId || metadata.company_details?.id || metadata.company_number,
          googleReviewId: metadata.company?.google_review_id || metadata.company_details?.google_review_id,
          invoiceNumber: metadata.invoiceId || metadata.invoice?.number || metadata.invoice_number,
          logoUrl: metadata.company?.logo_url || metadata.company_details?.logo_url
        },
        timestamp: Date.now(),
        expiryTime: Date.now() + CACHE_EXPIRY_DAYS * 24 * 60 * 60 * 1000
      }

      const cacheKey = pdfStore.getCacheKey(invoiceId, "invoice")
      localStorage.setItem(cacheKey, JSON.stringify(cacheData))

      console.log("[v0] Invoice PDF cached:", invoiceId)
      return true
    } catch (error) {
      console.error("[v0] Failed to cache invoice PDF:", error)
      return false
    }
  },

  storeReceiptPdf: (receiptId, pdfUrl, metadata = {}) => {
    try {
      const cacheData = {
        url: pdfUrl,
        metadata: {
          companyId: metadata.company_details?.id || metadata.company_number,
          googleReviewId: metadata.company_details?.google_review_id,
          receiptNumber: metadata.receipt_id,
          logoUrl: metadata.company_details?.logo_url || metadata.company?.logo_url
        },
        timestamp: Date.now(),
        expiryTime: Date.now() + CACHE_EXPIRY_DAYS * 24 * 60 * 60 * 1000
      }

      const cacheKey = pdfStore.getCacheKey(receiptId, "receipt")
      localStorage.setItem(cacheKey, JSON.stringify(cacheData))

      console.log("[v0] Receipt PDF cached:", receiptId)
      return true
    } catch (error) {
      console.warn("[v0] Failed to cache receipt PDF:", error)
      return false
    }
  },


  getInvoicePdf: (invoiceId) => {
    try {
      const cacheKey = pdfStore.getCacheKey(invoiceId, "invoice")
      const cached = localStorage.getItem(cacheKey)
      if (!cached) return null

      const cacheData = JSON.parse(cached)
      const now = Date.now()

      if (now > cacheData.expiryTime) {
        localStorage.removeItem(cacheKey)
        console.log(`[v0] Expired invoice cache removed: ${invoiceId}`)
        return null
      }

      console.log(`[v0] Invoice PDF loaded from cache: ${invoiceId}`)
      return { url: cacheData.url, metadata: cacheData.metadata }
    } catch (error) {
      console.error("[v0] Failed to retrieve cached invoice PDF:", error)
      return null
    }
  },


  getReceiptPdf: (receiptId) => {
    try {
      const cacheKey = pdfStore.getCacheKey(receiptId, "receipt")
      const cached = localStorage.getItem(cacheKey)
      if (!cached) return null

      const cacheData = JSON.parse(cached)

      if (Date.now() > cacheData.expiryTime) {
        localStorage.removeItem(cacheKey)
        console.log("[v0] Receipt PDF cache expired, removed:", receiptId)
        return null
      }

      console.log("[v0] Receipt PDF loaded from cache:", receiptId)
      return { url: cacheData.url, metadata: cacheData.metadata }
    } catch (error) {
      console.warn("[v0] Failed to retrieve cached receipt PDF:", error)
      return null
    }
  },


  clearCache: (id, type = "invoice") => {
    const cacheKey = pdfStore.getCacheKey(id, type)
    localStorage.removeItem(cacheKey)
  },


  clearAllCache: () => {
    const keys = Object.keys(localStorage)
    keys.forEach((key) => {
      if (key.startsWith(INVOICE_CACHE_PREFIX) || key.startsWith(RECEIPT_CACHE_PREFIX)) {
        localStorage.removeItem(key)
      }
    })
  },

  getCacheInfo: () => {
    const keys = Object.keys(localStorage)
    const invoiceCaches = keys.filter((key) => key.startsWith(INVOICE_CACHE_PREFIX))
    const receiptCaches = keys.filter((key) => key.startsWith(RECEIPT_CACHE_PREFIX))
    let totalSize = 0

    ;[...invoiceCaches, ...receiptCaches].forEach((key) => {
      try {
        const data = JSON.parse(localStorage.getItem(key))
        totalSize += data.size || 0
      } catch (e) {
        localStorage.removeItem(key) 
      }
    })

    return {
      invoiceCount: invoiceCaches.length,
      receiptCount: receiptCaches.length,
      totalCount: invoiceCaches.length + receiptCaches.length,
      totalSize,
      totalSizeMB: (totalSize / (1024 * 1024)).toFixed(2),
    }
  },
}
